import React from "react";
import { Link, LinkProps } from "react-router-dom";

type Props = React.PropsWithChildren<
    Omit<LinkProps, "to"> & {
        to: LinkProps["to"] | undefined | null;
    }
>;

export function OptionalLink(props: Props) {
    if (!props.to) {
        return <>{props.children}</>;
    } else {
        return (
            <Link {...props} to={props.to}>
                {props.children}
            </Link>
        );
    }
}
